module.exports = __webpack_public_path__ + "img/codigo-barras.eeae7c7e.svg";